export default "/assets/images/mila-sock-without.51b08bae211d5962.webp";